import Service from "./BaseService";

const get = (name: string, config?: any) =>
  Service.get("/images/damages?name=" + encodeURIComponent(name), config);

const save = (name: string, payload: any, config?: any) =>
  Service.upload(
    "/images/damages?name=" + encodeURIComponent(name),
    payload,
    config
  );

const dataUrlToFile = (dataUrl: string, filename: string) => {
  const [header, base64] = dataUrl.split(",");
  const mime = header.match(/data:(.*?);base64/)?.[1] || "image/jpeg";
  const binary = atob(base64 || dataUrl);
  const bytes = new Uint8Array(binary.length);

  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new File([bytes], filename, { type: mime });
};

const submitDamage = (name: string, config?: any) =>
  get(name, { nonLoading: true }).then((response) => {
    if (!response) return undefined;

    const formData = new FormData();
    const damages = response.data || {};

    ["front", "back", "left", "right"].forEach((side) => {
      if (damages[side]) {
        formData.append("images", dataUrlToFile(damages[side], `${side}.jpg`));
      }
    });

    return Service.upload("/v2/ZURAGU-predict", formData, {
      ...config,
      nonLoading: true,
    });
  });

const calcPrice = (config: any) =>
  Service.get("/images/calc-price", { ...config, nonLoading: true });

const summary = () => Service.get("/images/summary");

const savingDamageResult = (payload: any, config: any) =>
  Service.create(`/images/verify-result`, payload, config);

const DamageService = {
  get,
  save,
  submitDamage,
  calcPrice,
  savingDamageResult,
  summary,
};

export default DamageService;
